var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{style:({
      left: '240px',
    }),attrs:{"app":"","tile":"","height":"50px","color":"white"}},[_c('v-spacer'),_c('button',{staticClass:"btn mr-5",staticStyle:{"height":"32px"},on:{"click":function($event){_vm.isSwitchLanguageShow = !_vm.isSwitchLanguageShow}}},[_c('v-icon',{staticClass:"mr-2",style:({
          'font-size': '20px',
          transform: 'translateY(0.3px)',
        })},[_vm._v("language")]),_c('span',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.local.display_name))])],1),_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
        var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mr-2",style:({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            color: '#ffffff',
            'min-width': 0,
            backgroundColor: '#1e50c0',
          })},'v-btn',attrs,false),on),[_vm._v(" JB ")])]}}])},[_c('v-list',[_c('v-list-item',{attrs:{"link":""}},[_c('v-list-item-title',[_vm._v("修改密碼")])],1),_c('v-list-item',{attrs:{"link":""}},[_c('v-list-item-title',{on:{"click":_vm.onLogout}},[_vm._v("登出")])],1)],1)],1)],1),_c('SwitchLanguage',{attrs:{"isShow":_vm.isSwitchLanguageShow},on:{"cancel-event":function($event){_vm.isSwitchLanguageShow = !_vm.isSwitchLanguageShow},"confirm-event":function($event){_vm.isSwitchLanguageShow = !_vm.isSwitchLanguageShow}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }